import { useNavigate } from "react-router-dom";
import style from "./appModePage.module.scss";
import useAuth from "../../hooks/useAuth";
import AccountHeader from "../../components/AppAccount/AccountHeader";
import AccountForLoggedInUser from "../../components/AppAccount/AccountForLoggedInUser";
import UnauthenticatedUser from "../../components/AppAccount/UnauthenticatedUser";

const AccountLandingPage = () => {
  const navigate = useNavigate();
  const { isLogged } = useAuth();


  return (
    <div className={style.accountContainer}>
      <AccountHeader headername="My Account" />
      {isLogged ? (
          <AccountForLoggedInUser  />
      ) : (
          <UnauthenticatedUser />
      )}

    </div>
  );
};

export default AccountLandingPage;
